// import React from "react";
import { Link } from "react-router-dom";

// import css
import "./BusinessOneBanner.scss";

const BusinessOneBanner = () => {
  return (
    <section
      className="business_one_banner_parent"
      style={{
        backgroundImage:
          "url('/assets/img/business/businessone/home/banner1.jpg')",
      }}
    >
      <div className="container">
        <div
          className="big_circle"
          style={{
            backgroundImage:
              "url('/assets/img/business/businessone/home/banner_circle_bg.webp')",
          }}
        >
          <div className="bc_inner">
            <h6>experience the taste of india</h6>
            <h2>Great dining</h2>
            <div className="typing_text"><h6>Restaurant</h6></div>
            <Link className="theme_btn btn_center">Our Menus</Link>
            <img
              src="/assets/img/business/businessone/home/banner_motion_img.webp"
              alt=""
              className="motion_img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessOneBanner;
